import { IRIS } from './component-iris';
import { reactForceAllUpdate } from './component-react';
export const svrtsRequest = (obj) => {
    IRIS.Send({
        data: {
            forceTS: true,
            ...obj.data,
            progID: obj.data.funcID[0],
            funcID: obj.data.funcID[1],
        },
        yes: data => {
            obj.yes(data);
            reactForceAllUpdate();
        },
        no: obj.no,
        any: obj.any,
    });
};
//# sourceMappingURL=svrts-interface.js.map